module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"cornerstone-math","commonjs2":"cornerstone-math","amd":"cornerstone-math","root":"cornerstoneMath"}
// module id = 2
// module chunks = 0